import { BaseApi } from 'api/base.api'
import { ISettingsApi } from 'domains/settings/contracts/api'

export default class SettingsApi extends BaseApi implements ISettingsApi {
  constructor() {
    super('/v2/settings')
  }
}
